import request from '@/utils/request'
import { getToken } from '@/utils/auth'

const BASE_API_PREFIX_C = process.env.VUE_APP_BASIC_DATA_API_C

/**
 * 通过VIN查询ICCID集合
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/8244
 */
export const getIccidListByVin = (data) => {
  return request({
    url: `${BASE_API_PREFIX_C}newVinCard/queryUnBindCardByVin`,
    data
  })
}

/**
 * 通过VIN查询绑定的ICCID集合
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/8244
 */
export const getBindIccidListByVin = (data) => {
  return request({
    url: `${BASE_API_PREFIX_C}newVinCard/queryBindCardByVin`,
    data
  })
}

/**
 * 短信发送
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/5136
 */
export const markupSendSms = data => {
  return request({
    url: `${BASE_API_PREFIX_C}sms/sendSmsRnr`,
    data
  })
}

/**
 * 文件上传
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/7156
 */
export const cuscImageUpload = data => {
  // 表单数据
  const form = new FormData()
  // 遍历数据
  Object.keys(data).forEach(key => {
    form.append(key, data[key])
  })
  return request({
    url: `${BASE_API_PREFIX_C}cuscImage/upload`,
    headers: {
      'Content-Type': 'multipart/form-data;',
      'Authorization': `bearer ${getToken()}`
    },
    data: form
  })
}

/**
 * 文件上传
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/7156
 */
export const fileUpload = data => {
  // 表单数据
  const form = new FormData()
  // 遍历数据
  Object.keys(data).forEach(key => {
    form.append(key, data[key])
  })
  return request({
    url: `${BASE_API_PREFIX_C}file/upload`,
    headers: {
      'Content-Type': 'multipart/form-data;',
      'Authorization': `bearer ${getToken()}`
    },
    data: form
  })
}

/**
 * 校验输入的vin号和iccid是否合法
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/5116
 */
export const verifyVinCards = data => {
  return request({
    url: `${BASE_API_PREFIX_C}newVinCard/checkVinCard`,
    data
  })
}

/**
 * 检查vin(企业实名H5)
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/11016
 */
export const checkVin = data => {
  return request({
    url: `${BASE_API_PREFIX_C}newVinCard/checkVin`,
    data
  })
}

/**
 * 提交自然人实名认证
 * @yapi http://10.166.2.23:3000/project/36/interface/api/11680
 */
export const submitRnr = data => {
  return request({
    url: `${BASE_API_PREFIX_C}personal/h5/submitRnr`,
    data
  })
}

/**
 * 活体检测结果回调
 * @yapi http://10.166.2.23:3000/project/36/interface/api/11676
 */
export const livenessCallback = data => {
  return request({
    url: `${BASE_API_PREFIX_C}personal/h5/livenessCallback`,
    data
  })
}

/**
 * 企业实名H5提交
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/10984
 */
export const submitEnterpriseRnr = data => {
  return request({
    url: `${BASE_API_PREFIX_C}enterprise/h5/submitRnr`,
    data
  })
}

/**
 * 企业实名H5活体回调
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/10988
 */
export const enterpriseLivenessCallback = data => {
  return request({
    url: `${BASE_API_PREFIX_C}enterprise/h5/livenessCallback`,
    data
  })
}

/**
 * OCR读取身份证照片信息
 * @yapi http://10.166.2.23:3000/project/36/interface/api/11768
 */
export const ocrIdcard = data => {
  return request({
    url: `${BASE_API_PREFIX_C}ocr/idCard`,
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/markup.js